import React, { Component } from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import {
	isEqual, isNull, isUndefined, isEmpty,
} from 'lodash';
import {
	Navbar, Nav, NavItem, NavDropdown, MenuItem,
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import utils from '@utils';
import PaymentActions from '@redux/payments';
import ReportActions from '@redux/reports';
import NavBarHeader from './header';
import NavBarItem from './navItem';
import NavBarUser from './user';

class Navigation extends Component {
	constructor(props) {
		super(props);

		const { user } = props;

		this.userMenuId = uuid();

		this.state = {
			src : user && user.ContactPhotoUrl ? user.ContactPhotoUrl : '',
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const lastProps = this.props;

		if (nextProps.user !== lastProps.user) {
			const { user } = nextProps;

			this.setState({
				src : user && user.ContactPhotoUrl ? user.ContactPhotoUrl : '',
			});
		}
	}

	componentDidMount = () => {
		// Register update-picture event
		utils.registerEventListener('update-picture', this.updatePicture);
	}

	shouldComponentUpdate = ({ user, match }, { src }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(user, lastProps.user)
			|| !isEqual(match, lastProps.match)
			|| !isEqual(src, lastState.src)
		);
	}

	updatePicture = (parameters) => {
		this.setState({
			src : parameters.src,
		});
	}

	onClickReport = () => {
		const {
			resetReportsListData,
		} = this.props;

		resetReportsListData();
	}

	logNavigation = (label) => () => {
		ReactGA.event({
			category : 'Navigation',
			action   : 'NavBar Click',
			label,
		});
	}

	render() {
		const {
			user,
			resetPayment,
		} = this.props;
		const { src } = this.state;

		if (isNull(user) || isUndefined(user) || isEmpty(user)) return <div />;

		return (
			<Navbar fluid className="navbar-square navbar-center">
				<NavBarHeader
					rootPath="/"
					logoPath="/images/rk-logo-new.png"
					tagName="For Client"
					tagType="orange"
					linkComponent={Link}
				/>
				<Navbar.Collapse>
					<Nav>
						<LinkContainer to="/overview" onClick={this.logNavigation('Overview')}>
							<NavItem>
								<NavBarItem
									icon="rkf rkf-dashboard"
									text="Overview"
								/>
							</NavItem>
						</LinkContainer>

						<LinkContainer to="/jobs" onClick={this.logNavigation('Jobs')}>
							<NavItem>
								<NavBarItem
									icon="rkf rkf-business"
									text="Jobs"
								/>
							</NavItem>
						</LinkContainer>

						<LinkContainer to="/payments" onClick={this.logNavigation('Payments')}>
							<NavItem onClick={resetPayment}>
								<NavBarItem
									icon="rkf rkf-dollar-circle"
									text="Payments"
								/>
							</NavItem>
						</LinkContainer>

						<LinkContainer to="/locations" onClick={this.logNavigation('Locations')}>
							<NavItem>
								<NavBarItem
									icon="rkf rkf-profile-cop"
									text="Locations"
								/>
							</NavItem>
						</LinkContainer>

						<LinkContainer to="/coordinators" onClick={this.logNavigation('Coordinators')}>
							<NavItem>
								<NavBarItem
									icon="rkf rkf-business"
									text="Coordinators"
								/>
							</NavItem>
						</LinkContainer>
					</Nav>
					<Nav pullRight>
						<NavDropdown
							id={this.userMenuId}
							className="user-options"
							title={(
								<NavBarUser
									src={src}
									firstName={user.FirstName || ''}
									lastName={user.LastName || ''}
								/>
							)}
						>
							<LinkContainer to="/account" onClick={this.logNavigation('Account')}>
								<MenuItem>
									<NavBarItem
										icon="rkf rkf-profile"
										text="Account"
									/>
								</MenuItem>
							</LinkContainer>

							<LinkContainer to="/reports" onClick={this.logNavigation('Reports')}>
								<MenuItem onClick={this.onClickReport}>
									<NavBarItem
										icon="rkf rkf-reports"
										text="Reports"
									/>
								</MenuItem>
							</LinkContainer>

							<If condition={user.IsStaffAdmin}>
								<LinkContainer to="/staff" onClick={this.logNavigation('Staff')}>
									<MenuItem>
										<NavBarItem
											icon="rkf rkf-users"
											text="Staff"
										/>
									</MenuItem>
								</LinkContainer>
							</If>

							<LinkContainer to="/logout" onClick={this.logNavigation('Logout')}>
								<MenuItem>
									<NavBarItem
										icon="rkf rkf-exit"
										text="Logout"
									/>
								</MenuItem>
							</LinkContainer>
						</NavDropdown>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		);
	}
}

Navigation.propTypes = {
	resetPayment         : PropTypes.func.isRequired,
	resetReportsListData : PropTypes.func.isRequired,
	user                 : PropTypes.object,
	match                : PropTypes.object,
};

Navigation.defaultProps = {
	user  : undefined,
	match : {},
};

const mapStateToProps = ({
	router : { match },
	app : { user },
}) => ({
	match,
	user,
});

const mapDispatchToProps = (dispatch) => ({
	resetPayment         : bindActionCreators(PaymentActions, dispatch).resetPaymentsFilter,
	resetReportsListData : bindActionCreators(ReportActions, dispatch).resetReportsListData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
